var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.bgc)},[_c('v-content',[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }